export default __webpack_public_path__ + "static/media/solutions-2k.a747099b.jpg";